<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6">
          <h4 class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Detalle entrada</h4>
        </div>
        <div class="col-sm-6 form__head__boxBtn">
          <button type="button" class="btn btn-secondary btn-sm waves-effect" (click)="cancel()"><i
              class="fas fa-arrow-left m-r-5"></i> Regresar
          </button>
          <button type="button" class="btn btn-light btn-sm" (click)="printer()">
            <i class="fas fa-print m-r-3"></i> Imprimir
          </button>
          <!-- <button type="button" class="btn btn-danger btn-sm waves-effect"  ><i
              class="far fa-trash-alt m-r-5"></i> Eliminar
          </button> -->
        </div>
      </div> <!-- end row -->
    </div>
  </div>
  <div class="col-lg-12" *ngIf="movement != null">
    <div class="card m-b-30" id="body">
      <div class="card-body faq-box">
        <div class="row">
          <div class="form-group col-lg-3">
            <label>N° entrada</label>
            <p class="m-0">{{movement.nro_voucher}}</p>
          </div>
          <div class="form-group col-lg-3">
            <label>Fecha entrada</label>
            <p class="m-0">{{movement.date_movement}}</p>
          </div>
          <div class="form-group col-lg-6">
            <label>Motivo entrada</label>
            <p class="m-0">{{movement.warehouse_concept}}</p>
          </div>

          <div class="form-group col-lg-3">
            <label>Destino almacén</label>
            <p class="m-0">{{movement.warehouse_description}}</p>
          </div>

          <div class="form-group col-lg-6">
            <label>Observaciones</label>
            <p class="m-0">{{movement.reason}}</p>
          </div>
        </div>
      </div>
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#product" role="tab" aria-selected="true">
            <span class="d-none d-md-block bold">Productos</span><span class="d-block d-md-none"><i
                class="mdi mdi-home-variant h5"></i></span>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane p-3 active" id="product" role="tabpanel">
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Nombre producto</th>
                  <th class="w-15 text-center">U. Medida</th>
                  <th class="w-15 text-right">Cantidad</th>
                  <th class="w-15 text-right">Precio compra</th>
                  <th class="w-15 text-center">Fecha vcto.</th>
                  <th class="w-15 text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of detail; let index_ = index">
                  <td>{{item.description}}</td>
                  <td class="w-15 text-center">{{item.unitmeasure}}</td>
                  <td class="w-15 text-right">{{item.quantity}}</td>
                  <td class="w-15 text-right">{{item.price}}</td>
                  <td class="w-15 text-center">{{item.date_expiration}}</td>
                  <td class="w-15 text-right">
                    <span class="bold">{{item.subtotal}}</span>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
